export function generalDisclaimer(){
    return "If you believe there has been an error with this transaction, or seeking information regarding a refund, please contact support immediately at 855-524-8786 or support@bitstop.co. You can also visit the Bitstop.co website to learn more about our terms of service, refund policy, delivery policy, and more."
}

export function parseDisclaimerText(raw, language) {
  if (!raw) return raw;
  try {
    const parsed = JSON.parse(raw);
    return parsed[language] || parsed.en || raw;
  } catch (e) {
    return raw;
  }
}